'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'rv';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = ['M64 438.8c0 .4 0 .8 0 1.2 0 48.6 39.4 88 88 88 40.3 0 74.2-27.1 84.7-64 2.2-7.6 3.3-15.7 3.3-24 0-48.6-39.4-88-88-88-48.2 0-87.3 38.8-88 86.8zM192 440a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM352 208l0 232c0 48.6 39.4 88 88 88 40.3 0 74.2-27.1 84.7-64l51.3 0 0-164.2-8.1-9.1-64-72-9.5-10.7-142.4 0zM480 440a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM416 272l49.6 0 42.7 48-92.3 0 0-48z', 'M352 0l-160 0 0 32-192 0 0 328.6 5.4 6.6 58.6 71.6c.6-48 39.8-86.8 88-86.8 48.6 0 88 39.4 88 88 0 8.3-1.2 16.4-3.3 24l67.3 0 0-304 272 0 0-128-224 0 0-32zM224 160l0 96-128 0 0-96 128 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;